"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAirportTransferEitherDirection = isAirportTransferEitherDirection;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const utils_1 = require("@daytrip/utils");
function isAirportTransferEitherDirection(direction) {
    if ((0, utils_1.isUndefinedOrNull)(direction)) {
        return false;
    }
    return direction === legacy_enums_1.AirportTransferDirection.FromAirport || direction === legacy_enums_1.AirportTransferDirection.ToAirport;
}
//# sourceMappingURL=is-airport-transfer-either-direction.js.map